import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import Select from 'react-select';

class FixedSelect extends Select {
  constructor(props) {
    super(props);
    this.onDocumentScroll = this.onDocumentScroll.bind(this);
  }
  onDocumentScroll() {
    if (this.state.isOpen) {
      this.setState({
        isOpen: false,
      });
    }
  }
  componentDidMount() {
    document.addEventListener('scroll', this.onDocumentScroll, false);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.onDocumentScroll, false);
  }

  handleTouchOutside(event) {
    if (
      this.wrapper &&
      !this.wrapper.contains(event.target) &&
      this.menuContainer &&
      !this.menuContainer.contains(event.target) &&
      this.menu &&
      !this.menu.contains(event.target)
    ) {
      this.closeMenu();
    }
  }

  renderOuter(options, valueArray, focusedOption) {
    const dimensions = this.wrapper ? this.wrapper.getBoundingClientRect() : null;
    const menu = super.renderMenu(options, valueArray, focusedOption);

    if (!menu || !dimensions) return null;

    const selectMask = {
      position: 'relative',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    };

    const maxHeight = document.body.offsetHeight - (dimensions.top + dimensions.height);
    return createPortal(
      <Fragment>
        <div style={selectMask} />
        <div
          ref={ref => {
            this.menuContainer = ref;
          }}
          className="Select-menu-outer"
          onClick={e => {
            e.stopPropagation();
          }}
          style={{
            ...this.props.menuContainerStyle,
            zIndex: 9999,
            position: 'absolute',
            width: dimensions.width,
            top: window.pageYOffset + dimensions.top + dimensions.height,
            left: window.pageXOffset + dimensions.left,
            maxHeight: Math.min(maxHeight, 200),
            overflow: 'hidden',
          }}>
          <div
            ref={ref => {
              this.menu = ref;
            }}
            role="listbox"
            tabIndex={-1}
            className="Select-menu"
            id={`${this._instancePrefix}-list`}
            style={{
              ...this.props.menuStyle,
              maxHeight: Math.min(maxHeight, 200),
            }}
            onScroll={this.handleMenuScroll}
            onMouseDown={this.handleMouseDownOnMenu}>
            {menu}
          </div>
        </div>
      </Fragment>,
      document.body,
    );
  }
}

export default FixedSelect;
